import { createAction, props } from '@ngrx/store';

import { Entity } from '@apps/auth/domain/models/back';
import { AppliRole } from '@apps/back/models';

export const BackAuthEntityIdentityUpdateRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Identity Update Requested',
    props<{ external: boolean, entity: Entity }>()
);
export const BackAuthEntityIdentityUpdateSucceeded = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Identity Update Succeeded',
    props<{ external: boolean, entity: Entity }>()
);
export const BackAuthEntityIdentityUpdateFailed = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Identity Update Failed'
);
export const BackAuthEntitySdmAliasUploadRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Sdm Alias Upload Requested',
    props<{ file: File }>()
);
export const BackAuthEntityHabsUpdateRequested = createAction(
    '[BACK-AUTH-ENTITY] Back Auth Entity Habs Update Requested',
    props<{ external: boolean, entityId: string, habs: AppliRole[] }>()
);